import { atom } from "jotai";
import {
    deleteStuTag,
    getStudentsByWeekTimeId,
    makeStuTag
} from "service/rollCall";
import { atomWithDefault } from "jotai/utils";
import { useAtomValue, useSetAtom } from "jotai";
import { useMemo, useState } from "react";
import _ from "underscore";
import { message } from "antd";
import { errorMessage } from "service/service";
import { sleep } from "utils/common";

// 页面参数
export const paramsAtom = atom({
    weekTimeId: 0,
    courseNo: "",
    courseSeq: ""
});

/** 列表  *******************************************************************/

// 学生列表
export const stuListAtom = atomWithDefault(async get => {
    const params = get(paramsAtom);
    return await getStudentsByWeekTimeId(params.weekTimeId);
});

// 搜索过的学生列表
export const filteredStuListAtom = atom(get => {
    const searchText = get(searchTextAtom).trim();
    const stuList = get(stuListAtom);

    return stuList.filter(item => {
        if (item.name.indexOf(searchText) !== -1) return true;
        return item.studentNo === searchText;
    });
});

// 搜索条件
export const searchTextAtom = atom("");

// 添加标签
export function useAddTag() {
    const { weekTimeId } = useAtomValue(paramsAtom);
    const setStuList = useSetAtom(stuListAtom);

    return async (stuNo: string, text: string) => {
        if (text.trim() === "") return;

        try {
            await makeStuTag(stuNo, weekTimeId, text);
            const newStuList = await getStudentsByWeekTimeId(weekTimeId);
            setStuList(newStuList);
        } catch (e) {
            message.error(errorMessage(e));
        }
    };
}

/**
 * 删除tag
 */
export function useRemoveTag() {
    const { weekTimeId } = useAtomValue(paramsAtom);
    const setStuList = useSetAtom(stuListAtom);

    return async (markId: number) => {
        try {
            await deleteStuTag(markId);
            const newStuList = await getStudentsByWeekTimeId(weekTimeId);
            setStuList(newStuList);
        } catch (e) {
            message.error(errorMessage(e));
        }
    };
}

/** 弹出层  *******************************************************************/

// 是否显示选人对话框
export const showModalAtom = atom(false);

// 当前选择的学生号
export const currentStuNoAtom = atom("");

// 当前选择的学生信息
export const currentStuInfoAtom = atom(get => {
    const currentStuNo = get(currentStuNoAtom);
    const stuList = get(stuListAtom);
    return stuList.find(item => item.studentNo === currentStuNo);
});

// 开始随机选择
export function useShuffle() {
    const [shuffling, setShuffling] = useState(false);
    const [random, setRandom] = useState(0);
    const stuList = useAtomValue(stuListAtom);
    const setCurrentStuNo = useSetAtom(currentStuNoAtom);
    const stuNoList = useMemo(
        () => _.shuffle(_.pluck(stuList, "studentNo")),
        [stuList, random]
    );

    // 从随机列表中选前10个循环
    async function shuffle() {
        setShuffling(true);
        for (let i = 0; i < 10; i++) {
            await sleep(50);
            setCurrentStuNo(stuNoList[i % stuNoList.length]);
        }
        setRandom(random + 1);
        setShuffling(false);
    }

    return {
        start: shuffle,
        shuffling
    };
}

// 关闭选人框以后初始化状态
export function useClearModalState() {
    const setModalVisible = useSetAtom(showModalAtom);
    const setCurrentStuNo = useSetAtom(currentStuNoAtom);

    return () => {
        setModalVisible(false);
        setCurrentStuNo("");
    };
}
